<ng-container *ngIf="documentDetails$ | async as documentDetails">
  <ng-container
    *ngIf="
      documentDetails.complementaryMaterial?.length > 0 &&
      litComponentType === 'Complimentary Literature'
    "
  >
    <ft-literature-complementary-common
      [isHandheld$]="isHandheld$"
      [isMobile$]="isMobile$"
      [thumbnails$]="complementaryThumbnails$"
      title="{{ 'literature.lit-complementary-literature-title' | translate }}"
      downloadButtonText="{{
        'literature.lit-listing-download-pdf' | translate
      }}"
      [titleLinkBase]="titleLinkBase"
    ></ft-literature-complementary-common>
  </ng-container>
  <ng-container
    *ngIf="
      documentDetails.mandatoryMaterial?.length > 0 &&
      litComponentType === 'Mandatory Literature'
    "
  >
    <ft-literature-complementary-common
      [isHandheld$]="isHandheld$"
      [isMobile$]="isMobile$"
      title="{{ 'literature.lit-mandatory-literature-title' | translate }}"
      subTitle="{{
        'literature.lit-mandatory-literature-subtitle' | translate
      }}"
      downloadButtonText="{{
        'literature.lit-listing-download-pdf' | translate
      }}"
      [thumbnails$]="mandatoryThumbnails$"
      [titleLinkBase]="titleLinkBase"
    ></ft-literature-complementary-common>
  </ng-container>
  <ng-container
    *ngIf="
      documentDetails.mandatoryMaterial?.length > 0 &&
      litComponentType === 'Shareholder Related Documents'
    "
  >
    <ft-literature-complementary-common
      [isHandheld$]="isHandheld$"
      [isMobile$]="isMobile$"
      title="{{ 'literature.lit-related-literature-title' | translate }}"
      downloadButtonText="{{
        'literature.lit-listing-download-pdf' | translate
      }}"
      [thumbnails$]="shareHoldersRelatedThumbnails$"
      [titleLinkBase]="titleLinkBase"
    ></ft-literature-complementary-common>
  </ng-container>
</ng-container>
